import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { FOOTER_NAV } from "@/content/contentPages";
import { ShieldCheck, Eye, Users, Target, Globe } from "lucide-react";

const values = [
  { icon: ShieldCheck, title: "Trust", desc: "Built on authenticity and verification." },
  { icon: Eye, title: "Transparency", desc: "Open data. Clear intent. No hidden agendas." },
  { icon: Users, title: "Community", desc: "Real people sharing real experiences." },
  { icon: Target, title: "Impact", desc: "Better decisions lead to better outcomes." },
];

export function Footer() {
  return (
    <footer className="mt-24 border-t border-[#DDDAD1] bg-ink-950/60">
      <div className="mx-auto max-w-[1800px] px-6 py-14 sm:px-10 lg:px-16">
        {/* Values */}
        <div className="grid grid-cols-2 gap-6 sm:grid-cols-4">
          {values.map((v) => (
            <div key={v.title}>
              <span className="grid h-9 w-9 place-items-center rounded-lg bg-teal-500/15 text-teal-400">
                <v.icon className="h-5 w-5" aria-hidden="true" />
              </span>
              <p className="mt-3 text-xs font-semibold uppercase tracking-[0.15em] text-teal-400">{v.title}</p>
              <p className="mt-1 text-sm text-slate-400">{v.desc}</p>
            </div>
          ))}
        </div>

        {/* Brand + nav columns */}
        <div className="mt-14 grid gap-10 border-t border-[#DDDAD1] pt-12 lg:grid-cols-[1.4fr_2.6fr]">
          <div>
            <Logo size={28} />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
              iGamingTruth is an independent platform for verified employee and candidate reviews. Reviews are the opinions and personal accounts of their authors, not statements by iGamingTruth. Companies named on this site can respond to any review free of charge.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {FOOTER_NAV.map((col) => (
              <div key={col.heading}>
                <p className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">{col.heading}</p>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l.slug}>
                      <Link to={`/p/${l.slug}`} data-testid={`footer-${l.slug}`} className="text-sm text-slate-400 transition-colors hover:text-teal-400">
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-[#DDDAD1] pt-6 sm:flex-row sm:items-center">
          <p className="font-heading text-sm font-medium tracking-wide text-slate-300">Verified reviews from inside iGaming.</p>
          <a href="#" className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-teal-400">
            <Globe className="h-4 w-4" aria-hidden="true" /> igamingtruth.org
          </a>
        </div>
      </div>
    </footer>
  );
}
